export const REDIRECT_PARAM = 'redirectUri';
const REDIRECT_STORAGE_KEY = 'incase-player-redirect-uri';
const SCHEME_PATTERN = /^[a-zA-Z][a-zA-Z0-9+.-]*:/;

export function isRedirectParam(key: string): boolean {
    return key === REDIRECT_PARAM;
}

export function omitRedirectParams(params: {[key: string]: string}): {[key: string]: string} {
    return Object.fromEntries(Object.entries(params).filter(([key]) => !isRedirectParam(key)));
}

export function normalizeRedirectUri(uri: string): string | null {
    const trimmed = uri.trim();
    if (!trimmed) return null;

    const withProtocol = SCHEME_PATTERN.test(trimmed) ? trimmed : `https://${trimmed}`;

    try {
        const {protocol} = new URL(withProtocol);
        return protocol === 'http:' || protocol === 'https:' ? withProtocol : null;
    } catch {
        return null;
    }
}

export function getStoredRedirectUri(): string | null {
    return sessionStorage.getItem(REDIRECT_STORAGE_KEY);
}

export function setStoredRedirectUri(uri: string | null): void {
    if (uri) sessionStorage.setItem(REDIRECT_STORAGE_KEY, uri);
    else sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
}
